import { render, staticRenderFns } from "./updateTaskremark.vue?vue&type=template&id=f0a04c9c&scoped=true"
import script from "./updateTaskremark.vue?vue&type=script&lang=js"
export * from "./updateTaskremark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a04c9c",
  null
  
)

export default component.exports